//Librerie esterne
import { useTranslation } from "react-i18next";

const BannerVendi: React.FC = () => {

    const { t } = useTranslation();
    
    return (
        <section id="bannerVendi" className="space-ptb">
            <div className="container-fluid">
                <div className="row align-items-center text-center">
                    <div className="col-12 col-xl-9 mb-4 mb-xl-0">
                        <h3 className="asH2SubTitle text-white mb-0">{t('homePage.valutationSection.title')}</h3>
                    </div>
                    <div className="col-12 col-xl-3">
                        <a href="/vendi-casa" className="btn btn-primary" title={`${t('homePage.valutationSection.btnTitle')}`}>
                            {t('homePage.valutationSection.btnText')}
                        </a>
                    </div>
                </div>
            </div>
        </section>
    )
}
export default BannerVendi